import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	CTA,
	ContainerGutter,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { GetPersonUser, NormalizedVoucher } from '@esportal/portal-service';
import { getClubId } from '../../../../helpers/nameHelper';
import { useBenefitsTracker } from '../hooks/use-benefits-tracker';

export const VouchersvwBank: React.FC<{
	vwBankUrl: string;
	userData: GetPersonUser | null;
	vouchersPopupData: NormalizedVoucher;
}> = ({ vwBankUrl, userData, vouchersPopupData }) => {
	const { trackVwBankLayerLoad, trackVwBankButtonClick } = useBenefitsTracker();

	React.useLayoutEffect(() => {
		trackVwBankLayerLoad(vouchersPopupData);
	}, []);

	return (
		<Container
			padding={{
				top: ContainerPadding.dynamic0270,
				right: ContainerPadding.dynamic0270,
				bottom: ContainerPadding.dynamic0270,
				left: ContainerPadding.dynamic0270,
			}}
			gutter={ContainerGutter.dynamic0100}
			stretchContent
		>
			<Container horizontalAlign={'center'}>
				<Text appearance={TokenTextAppearance.headline500} bold>
					Estás saliendo de tu portal de cliente
				</Text>
			</Container>
			<Text appearance={TokenTextAppearance.copy200}>
				{
					'Si seleccionas “Continuar” saldrás del Club Volkswagen y se te redirigirá a la web de Volkswagen Bank GmbH Sucursal en España. Por lo que te informamos que VOLKSWAGEN GROUP ESPAÑA DISTRIBUCIÓN, S.A.U. (en adelante VGED) comunicará toda aquella información necesaria para la contratación del Depósito Volkswagen Bank a Volkswagen Bank GmbH Sucursal en España. Esta cesión de datos es necesaria para continuar con la contratación del Depósito Volkswagen Bank en Volkswagen Bank GmbH Sucursal en España.'
				}
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				Puedes ejercer los derechos de protección de datos frente a VGED enviando un correo electrónico a{' '}
				<CTA tag="a" emphasis="tertiary" href="mailto:atencioncliente@volkswagen.es">
					<Text appearance={TokenTextAppearance.copy200}>atencioncliente@volkswagen.es</Text>
				</CTA>
				. Para más información, puedes consultar la política de Privacidad de VGED en el siguiente{' '}
				<CTA
					tag="a"
					emphasis="tertiary"
					href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
					target="_blank"
				>
					<Text appearance={TokenTextAppearance.copy200}>link.</Text>
				</CTA>
			</Text>
			<CTA
				tag="button"
				emphasis="primary"
				onClick={() => {
					trackVwBankButtonClick(vouchersPopupData, 'Continuar');
					window.open(vwBankUrl + getClubId(userData), '_blank');
				}}
			>
				Continuar
			</CTA>
		</Container>
	);
};
